module.exports = __webpack_public_path__ + "img/trade.9028612c.png";